export enum ETipoTabelaPreco {
    Cliente = 1,
    Cidade = 2,
    Estado = 3,
    Regiao = 4,
}
